<template>
    <div>
        <p class="instruction">
            <i class="fa fa-info-circle"></i> 使用說明：此工具能協助計算各生長階段日期。<br>
            只需輸入種植日期，系統會自動帶入期作地點、作物品種及氣象資訊進行計算。若無該年份氣象資料，將用該氣象站平均值進行計算。
        </p>
        <div>
            <div v-if="loading">
                <AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading>
            </div>
            <b-row align-v="center">
                <div v-if="admim_use == false" class="crop-name">
                    {{ crop_name }}
                </div>

                <b-col sm=6 lg=3 v-if="admim_use">
                    <!-- 作物 -->
                    <b-input-group class="mb-3">
                        <b-input-group-prepend>
                            <b-input-group-text><i class="fa fa-leaf"></i>{{ $t('n.crop') }} *</b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-select v-if="admim_use" v-model="input_data.select_crop" :options="list_crops" :select-size="4"></b-form-select>

                        <template v-else>
                            <b-form-select :value="input_data.select_crop" :options="list_crops" :disabled="true"></b-form-select>
                        </template>
                       
                    </b-input-group>
                </b-col>

                <b-col sm=6 lg=3 v-if="admim_use">
                    <!-- 品種 -->
                    <b-input-group class="mb-3">
                        <b-input-group-prepend>
                            <b-input-group-text><i class="fa fa-leaf"></i>{{ $t('n.variety') }} *</b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-select v-if="admim_use" v-model="input_data.select_crop_code" :options="list_cultivars" :select-size="4"></b-form-select>
                        
                        <template v-else>
                            <b-form-select :value="input_data.select_crop_code" :options="list_cultivars" :disabled="true"></b-form-select>
                        </template>
                    </b-input-group>
                </b-col>

                <b-col sm=6 lg=3>
                    <!-- 日期選擇 -->
                    <b-input-group class="mb-3">
                        <b-input-group-prepend>
                            <b-input-group-text>
                                {{ $t('menu.planting_day') }}
                            </b-input-group-text>
                        </b-input-group-prepend>
                        <div class="d-inline-block">
                            <date-picker v-model="input_data.planting_data"
                                        :lang="$tools.lang.date_picker(language)"
                                        :clearable="false" :width="130"
                                        :placeholder="$t('menu.select_date')"
                                        :not-before="'2015-06-01'"
                                        format="YYYY-MM-DD"
                            ></date-picker>
                        </div>
                    </b-input-group>
                </b-col>

                <b-col sm=6 lg=3>
                    <div class="mb-3">
                        <b-button variant="success" size="lg" @click="get_Prediction" :disabled="checkDisabled">
                            {{ $t('menu.harvest_prediction') }} <i class="fa fa-calculator"></i>
                        </b-button>
                    </div>
                </b-col>
            </b-row>
            
            
            <div v-if="loading_result">
                <AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading>
            </div>
            <div v-if="result != undefined">

                <div class="result-chart">
                    <StageDateBarChart :chartID="'chart-growth-stage-prediction'" :data="result"></StageDateBarChart>
                </div>

                <div class="result-title">
                    <b-alert show variant="info">
                        <i class="fa fa-thumbs-up faa-vertical animated"></i>
                        {{ crop_name }} 預測收成日：
                        <div class="result-date">{{ this.$moment( result.final_date ).add(-2, 'days').format('YYYY-MM-DD') }}</div>
                        <i class="fa fa-minus"></i>
                        <div class="result-date">{{ this.$moment( result.final_date ).add(2, 'days').format('YYYY-MM-DD') }}</div>
                    </b-alert>
                </div>
            </div>  

        </div>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import NoData      from '@/views/components/NoData'
import AgriLoading from '@/views/components/AgriLoading'
import StageDateBarChart from '@/views/echarts/BarChart_StageDate'
import DatePicker from 'vue2-datepicker'

export default {
    props: {
        timezone: {
            type: String,
            default: 'Asia/Taipei',
        },
        date_start: { // 種植日期
            type: String,
            default: undefined,
        },
        crop_code: { // 作物 8 碼
            type: String,
            default: undefined,
        },
        device_id: {  // Hashid, SUID
            type: String,
            default: undefined,
        },
        admim_use: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        DatePicker,
        AgriLoading,
        StageDateBarChart,
        NoData,
    },
    data () {
        return {
            loading: false,
            loading_result: false,
            date_today: undefined,

            list_crops: [],
            list_cultivars: [],
            input_data: {
                planting_data: undefined,
                select_crop: undefined,
                select_crop_code: undefined,
            },
            result: undefined,
        }
    },
    mounted ()
    {
        // 取得所有作物列表
        this.get_CropInfo();

        this.date_today = this.$tools.date.getDateNow(this.timezone, 'YYYY-MM-DD 23:59');

        if ( this.date_start )  this.input_data.planting_data = this.date_start
        else                    this.input_data.planting_data = this.date_today

    },
    computed: {
        ...mapState({
            'language': state => state.user.language,
        }),

        checkDisabled ()
        {
            if ( this.input_data.select_crop == undefined ) return true
            if ( this.input_data.select_crop_code == undefined ) return true
            if ( this.input_data.planting_data == undefined ) return true
        },

        crop_name ()
        {
            let _name = ''
            
            if ( this.list_crops.length > 0 )
            {
                this.list_crops.forEach( _crop => {
                    if ( _crop.value == this.crop_code.slice(0,4) ) _name += _crop.name
                })

                if ( this.list_cultivars.length > 0 )
                {
                    this.list_cultivars.forEach( _cultivar => {
                        if ( _cultivar.value == this.crop_code ) _name += ' ' + _cultivar.name
                    })
                }
            }
            return _name
        },
    },
    watch: {

        date_start   (val, oldVal) { if (val != undefined) this.input_data.date_start = val },
        crop_code    (val, oldVal) { if (val != undefined) this.input_data.select_crop = val },

        // 偵測到 [ 語言 ] 變動就更新作物清單
        language() {
            this.get_CropInfo();
            this.get_CropInfo(this.input_data.select_crop);
        },

        'input_data.select_crop'(val, oldVal) {

            this.get_CropInfo(this.input_data.select_crop);
        },

    },
    methods: {

        get_Prediction ()
        {
            this.loading_result = true
            let _query = {
                start_date: this.$moment( this.input_data.planting_data ).format('YYYY-MM-DD'),
                crop_code:  this.input_data.select_crop_code,
                hashid:     this.device_id,
            }
            const options = {
                method: 'GET',
                url: this.$config.getAPI_URL('Get_Rice_Harvest', _query),
            }
            this.$http(options)
            .then( res => {

                if ( res.data )
                {
                    this.result = res.data
                }
                else this.result = undefined

                this.loading_result = false
            })
            .catch( err => {
                this.loading_result = false
            })
        },

        // 取得作物&品種清單：
        // 無 cropCode 表示要撈 [ 作物 ] 清單，有 cropCode 表示要撈該作物代碼下的 [ 品種 ] 清單
        get_CropInfo (cropCode = undefined)
        {
            this.loading = true;

            let _url = '';
            if (cropCode == undefined)  _url = this.$config.getAPI_URL('Get_Crops')
            else                        _url = this.$config.getAPI_URL('Get_Cultivars', { cropCode: cropCode })
            
            const options = {
                method:'GET',
                url: _url,
            }
            this.$http(options)
                .then(res => {
                    this.loading = false;
                    // console.log( res.data )
                    if ( res.data )
                    {
                        if ( cropCode != undefined )
                        {
                            this.list_cultivars = res.data.map( _crop => {
                                return {
                                    value: _crop.crop_code,
                                    text: '<div class="input-crop-code">' + _crop.id + '</div>'
                                        + '<div class="input-crop-name">' + _crop.cultivar_name + '</div>',
                                    name: _crop.cultivar_name,
                                    crop_code: _crop.crop_code,
                                    cultivar_code: _crop.crop_code.slice(4),
                                    has_rule: _crop.has_rule,
                                }
                            })

                            if ( this.list_cultivars.length > 0 )
                            {
                                if ( this.crop_code != undefined )
                                {
                                    this.input_data.select_crop_code = this.crop_code
                                }
                                // 無指定品種的話，取得作物品種後，預設選第一個品種
                                else this.input_data.select_crop_code = this.list_cultivars[0].value
                            }
                        }
                        else
                        {
                            this.list_crops = res.data.map( _crop => {
                                return {
                                    value: _crop.crop_id,
                                    text: '<div class="input-crop-code">' + _crop.crop_id + '</div>'
                                        + '<div class="input-crop-name">' + _crop.crop_name + '</div>',
                                    name: _crop.crop_name,
                                    has_rule: _crop.has_rule,
                                }
                            })

                            if ( this.list_crops.length > 0 )
                            {
                                if ( this.crop_code != undefined ) this.input_data.select_crop = this.crop_code.slice(0,4)
                            }
                        }
                    }

                })
                .catch(err => {
                    // console.log(err);
                    this.loading = false;
                })
        },

    },
}
</script>

<style lang="scss" scoped>

.crop-name
{
    display: inline-block;
    margin: 0px 10px 15px 30px;
    font-size: 1.2rem;
}

.fa-calculator
{
    margin-left: 10px;
    font-size: 1.4rem;
    color: #b4f375;
}

.result-chart
{
    overflow-x: auto;
}

.result-title
{
    text-align: center;
    margin: 10px 10px 25px 10px;
    font-size: 1.4rem;
    font-weight: 600;

    .alert
    {
        padding: 20px;
    }

    .fa-thumbs-up {
        vertical-align: middle;
        margin-top: -2px;
        font-size: 1.8rem;
        color: rgb(90, 157, 111);
    }
    .fa-minus
    {
        margin-right: 0px;
    }
}

.result-date
{
    display: inline-block;
    padding: 5px 10px;
}

</style>